import FlightDetailsAncillaryItem from "../../../../components/elements/FlightDetailsAncillaryItem/FlightDetailsAncillaryItem";
import { CancellationPartiallyRefundableIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { t } from "@bookingcom/lingojs-core";
import React from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { UIProductCancelForAnyReason } from "@flights/types";
import useFormatPrice from "../../../../hooks/useFormatPrice";

type CfarTicketItemProps = {
  showLoadingPrice?: boolean;
  cancelForAnyReason: UIProductCancelForAnyReason;
  /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
  condensedFDDesktop?: boolean;
  condensedFDMobile?: boolean;
  travellers?: number;
  /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
};

const CfarTicketItem = ({
  showLoadingPrice,
  cancelForAnyReason,
  condensedFDDesktop,
  condensedFDMobile,
  travellers = 1
}: CfarTicketItemProps) => {
  const { formatPrice } = useFormatPrice();
  const i18n = useI18n();

  const priceCopy =
    travellers === 1
      ? t("flights_fd_cfar_price_pp", {
          variables: { cfar_price: formatPrice(cancelForAnyReason.priceBreakdown.total) || "" }
        })
      : t("flights_fd_cfar_price_total", {
          variables: { cfar_price: formatPrice(cancelForAnyReason.priceBreakdown.total) || "" }
        });

  return (
    <FlightDetailsAncillaryItem
      type="cancelForAnyReason"
      icon={CancellationPartiallyRefundableIcon}
      showLoadingPrice={showLoadingPrice}
      title={i18n.trans(t("flights_fd_cfar_name"))}
      description={i18n.trans(t("flights_fd_cfar_description"))}
      priceCopy={i18n.trans(priceCopy)}
      /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
      condensedFDDesktop={condensedFDDesktop}
      condensedFDMobile={condensedFDMobile}
      /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
    />
  );
};

export default CfarTicketItem;
